import LinkRenderer from "@/components/common/LinkRenderer/LinkRenderer";
import { Translate } from "@/components/common/Translate/Translate";
import { getClipSnapSiteOrigin } from "client/config/externalEditors";

export const ClipSnapPromotion = () => {
    return (
        <div className="-mt-[124px] bg-[#EFF4FF] dark:bg-gray-800 dark:text-white max-w-[840px] mx-auto flex flex-col-reverse md:flex-row items-center justify-center gap-20 mb-[180px] md:text-left p-6 md:p-0">
            <div className="flex flex-col max-w-[472px] md:pl-16 md:py-[118px]">
                <div className="mb-6 leading-[40px] w-[255px] text-[30px] font-semibold">
                    <Translate keyName="common:clipsnap-promotion-title" />
                </div>
                <div className="mb-9 md:w-[267px]">
                    <Translate
                        keyName="common:clipsnap-promotion-paragraph-1"
                        linkRenderer={(label, key) => (
                            <LinkRenderer label={label} linkKey={key} className="text-blue-700 dark:text-irBlue-200" />
                        )}
                    />
                </div>
                <div className="pb-2 md:pb-0">
                    <a
                        className="cursor-pointer font-semibold md:text-xl bg-[#6E99F4] py-[14.5px] px-[18px] text-white rounded-md whitespace-nowrap"
                        target="_blank"
                        referrerPolicy="no-referrer"
                        href={getClipSnapSiteOrigin()}
                    >
                        <Translate keyName="common:clipsnap-promotion-button-text" />
                    </a>
                </div>
            </div>
            <div className="flex-shrink-0 w-full md:w-auto md:pr-[51px] flex items-center justify-center">
                <div className="relative w-full h-auto md:w-[400px] md:h-[400px] flex items-center justify-center">
                    <img
                        alt="ClipSnap Promotional Graphic"
                        src="https://content.imageresizer.com/images/clipsnap-promotional-graphic.png"
                        width={400}
                        height={400}
                    />
                </div>
            </div>
        </div>
    );
};
